var _style, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 137.4 150.3",
    style: {
      enableBackground: "new 0 0 137.4 150.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#09658D;}\r\n\t.st1{fill:#2598D5;}\r\n\t.st2{fill:#E5F4F9;}\r\n\t.st3{fill:#21B9EC;}\r\n\t.st4{opacity:0.4;fill:#FFFFFF;}\r\n\t.st5{opacity:0.85;fill:#FDFEFE;}\r\n\t.st6{opacity:0.3;fill:#FFFFFF;}\r\n\t.st7{opacity:0.85;fill:#FFFFFF;}\r\n\t.st8{fill:#1167A1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,12.9h101.9c9.8,0,17.8,8,17.8,17.8v101.9c0,9.8-8,17.8-17.8,17.8H17.8c-9.8,0-17.8-8-17.8-17.8V30.7 C0,20.8,8,12.9,17.8,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.8,6.2h101.9c9.8,0,17.8,8,17.8,17.8v101.9c0,9.8-8,17.8-17.8,17.8H17.8c-9.8,0-17.8-8-17.8-17.8V24 C0,14.2,8,6.2,17.8,6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.8,0h101.9c9.8,0,17.8,8,17.8,17.8v101.9c0,9.8-8,17.8-17.8,17.8H17.8c-9.8,0-17.8-8-17.8-17.8V17.8 C0,8,8,0,17.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.1,8.5h89.3c8.6,0,15.6,7,15.6,15.6v89.3c0,8.6-7,15.6-15.6,15.6H24.1c-8.6,0-15.6-7-15.6-15.6V24.1 C8.5,15.4,15.4,8.5,24.1,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.5,118.7l25.7-0.9C132.3,112.6,129,49,129,57.6v55.8c0,8.6-7,15.6-15.6,15.6H24.1c-8.6,0-15.6-7-15.6-15.6 v-10.2C23.7,115.5,25.7,118.8,52.5,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.1,8.5h89.3c8.6,0,15.6,7,15.6,15.6v4.4c0,8.6-2.6-11.8-15.6-11.8H24.1c-12.7,0-15.6,20.5-15.6,11.8v-4.4 C8.5,15.4,15.4,8.5,24.1,8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M35.4,13.7c0,0-7-3.8-12.2,0s-5.5,9-4.2,11.8c1.3,2.5,3.7,2.2,5.7-2.3s7.5-5.3,7.5-5.3S37.9,17.5,35.4,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M103.8,117.9l11.1-4.6c2.6-1.1,5.6-0.1,6.5,2.1v0c0.9,2.3-0.4,5-3.1,6.1l-11.1,4.6c-2.6,1.1-5.6,0.1-6.5-2.1v0 C99.7,121.7,101.1,119,103.8,117.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M124.2,111.6l1.5-0.6c0.6-0.3,2,0,2.4,0.8v0c0.4,0.9-0.3,2-0.9,2.2l-1.5,0.6c-0.6,0.3-2.1,0-2.4-0.8l0,0 C122.9,112.9,123.6,111.8,124.2,111.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.9,33.7l1.2-2.1c0.5-0.9,2.5-2,3.8-1.3l0,0c1.3,0.7,1.5,2.7,0.9,3.6l-1.2,2.2c-0.5,0.9-2.5,2-3.8,1.3h0 C12.6,36.7,12.4,34.6,12.9,33.7z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M44.5,80.2c-4.6,0-8.3-3.8-8.3-8.4c0-4.6,3.8-8.3,8.4-8.3l28.2,0.2L62.6,53.3c-3.2-3.3-3.2-8.6,0.1-11.8 c3.3-3.2,8.6-3.2,11.8,0.1l24.3,24.7c3.2,3.3,3.2,8.5,0,11.7L75,102.3c-3.2,3.3-8.5,3.3-11.8,0.1c-3.3-3.2-3.3-8.5-0.1-11.8 l10.1-10.2L44.5,80.2L44.5,80.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueNext);
export default __webpack_public_path__ + "static/media/blue-next.bd72c859bf6397034ae7e188ac516c23.svg";
export { ForwardRef as ReactComponent };